/* beautiful-react-hooks version: 0.31.1 */
import { useRef, useEffect } from 'react';

var usePreviousValue = function usePreviousValue(value) {
  var prevValue = useRef();
  useEffect(function () {
    prevValue.current = value;
    return function () {
      prevValue.current = undefined;
    };
  });
  return prevValue.current;
};

export default usePreviousValue;
